/*
 * @Author: lyx
 * @Date: 2024-09-07 16:47:37
 * @LastEditors: lyx 
 * @LastEditTime: 2024-09-07 16:47:37
 * @FilePath: /dbrank_b/src/routes/visualChart/P34/index.js
 * @Description: p34
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToComplexTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { getVisual } from '../../../controller';
import { drop, dropRight } from 'lodash';
import { index } from 'd3';

const defaultColorValue = '#ff0000\n#7f429f\n#58b6e5\n#ffba55\n#0071c0\n#808080\n#c00000\n#009999\n#00b050';

class FormChart extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      brandArr: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('34_chart').then(value => {
      const _table = FormChart.parse(value);
      const _color = FormChart.parseColor(defaultColorValue);


      this.setState({
        value: value,
        ..._table,
        ..._color,
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._color,
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;
    const brandArr = dataset[0].slice(2); // 品牌数组
    const source = drop(dataset, 1);
    const chartSource = source
    return {
      dataset,
      ...FormChart.parseChart(chartSource, brandArr),
    }
  }
 
  static parseChart = (dataset = [], brandArr = []) => {
    // console.log(dataset);
    const { axis: chartTitle, list: chartList } = dataset
      .map(item => item.slice(1))
      .reduce((acc, [name, ...value]) => {
        acc.axis.push(name);
        acc.list.push(value);
        return acc;
      }, { axis: [], list: [] }) 
    // console.log('chartList',chartList);
    
    return { chartTitle, chartList, brandArr }
  }

  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);
    
    return {
      chartColorList: chartColorList.map(([val]) => val)
    }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = FormChart.parse(value);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const colorValue = e.target.value;
    const _color = FormChart.parseColor(colorValue);

    this.setState({
      colorValue: colorValue,
      ..._color,
    });

    typeof onChange === 'function' && onChange(_color);
  }

  render() {
    return (
      <div className={s.root}>
        <div>DB数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(FormChart);



// WEBPACK FOOTER //
// src/routes/visualChart/P34/FormChart.js